import flatasticExpensesService from './svc_expenses';
import flatasticWgService from '../wg/svc_wg';
import yepptCordova from '../../scripts/modules/yptCordova';

export default angular.module('flatastic.expenses.controller.details', [
  flatasticExpensesService,
  flatasticWgService,
  yepptCordova,
  'ionic',
])

.controller('ExpensesDetailsCtrl',
    ['$scope', 'yptNotify', 'Expenses', 'User', '$state', '$stateParams', 'Wg',
    '$filter', '$rootScope',
    function ($scope, yptNotify, Expenses, User, $state, $stateParams, Wg,
    $filter, $rootScope) {

  $scope.user = User.properties;
  $scope.flatmates = Wg.flatmates;

  $scope.showHelp = function() {
    yptNotify.alert({
      title: $filter('translate')('EXP__DETAIL_HELP-TITLE'),
      message: $filter('translate')('EXP__DETAIL_HELP-MSG'),
      trackEvent: {
        name: 'showHelp',
        parameters: {
          context: 'expenses__details',
        },
      },
    });
    $rootScope.$broadcast('track-event', {
      category: 'Help',
      action: 'Clicked',
      label: '/expenses-details',
    });
  };

  $scope.expense = Expenses.get($stateParams.id);

  $scope.deleteExpense = function() {
    yptNotify.confirm({
      message: $filter('translate')('EXP__DELETE-MSG', {
        name: $scope.expense.name,
      }),
      title: $filter('translate')('EXP__DELETE-TITLE'),
      buttonLabels: [
        $filter('translate')('BTN_CANCEL'),
        $filter('translate')('DELETE'),
      ],
      callback: function(answer) {
        if (answer === true) {
          $scope.expense.removeFromCollection().delete();
          $state.go('wg.expenses');
        }
      },
    })
  };

}])

.name;
